import { render, staticRenderFns } from "./SavePassword.vue?vue&type=template&id=575e1b65&scoped=true&"
import script from "./SavePassword.vue?vue&type=script&lang=js&"
export * from "./SavePassword.vue?vue&type=script&lang=js&"
import style0 from "./SavePassword.vue?vue&type=style&index=0&id=575e1b65&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575e1b65",
  null
  
)

export default component.exports